<template>
  <v-menu
    v-model="showMenu"
    :close-on-content-click="false"
    :nudge-width="width"
    offset-y
    bottom
  >
    <template v-slot:activator="{ on }">
      <div
        id="customInput"
        :style="getCustomButtonStyle"
        :title="searchInputText"
        v-on="on"
      >
        {{ searchInputText }}
        <v-icon v-if="displayIcon" :color="getColor" :style="getIconStyle">
          arrow_drop_down
        </v-icon>
      </div>
    </template>

    <v-card id="menuCard" :class="{ 'pb-2': bottomPadding }">
      <slot name="drop-content" />
      <v-btn dark depressed @click="closeMenu">
        OK
      </v-btn>
    </v-card>
  </v-menu>
</template>

<script>
import { mapState } from 'vuex'
import colors from '../../../scss/_colors.scss'

export default {
  props: {
    searchInputText: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      required: true
    },
    width: {
      type: Number,
      default: 150
    },
    isFilled: {
      type: Boolean,
      default: false
    },
    displayIcon: {
      type: Boolean,
      default: false
    },
    bottomPadding: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      fav: true,
      message: false,
      hints: true
    }
  },

  computed: {
    ...mapState('common', ['searchObject']),

    getColor() {
      if (this.isFilled) {
        return this.searchObject.searchResult
          ? colors.hwayzKellyGreen
          : colors.hwayzBlack
      }
      return colors.hwayzShadow
    },

    getIconStyle() {
      return this.searchObject.searchResult
        ? { 'margin-bottom': '-4px' }
        : { 'margin-bottom': '-3px' }
    },

    getCustomButtonStyle() {
      let borderRadius = '0px'
      let height = '60px'
      let color = colors.hwayzShadow
      let borderColor = 'transparent'

      if (this.searchObject.searchResult) {
        borderRadius = '3px'
        height = '40px'
      }

      if (this.isFilled) {
        color = colors.hwayzKellyGreen
        if (this.searchObject.searchResult) {
          borderColor = colors.hwayzKellyGreen
        }
      }

      const btnStyles = {
        'border-radius': borderRadius,
        height,
        color,
        'line-height': height
      }
      return !this.searchObject.searchResult
        ? {
          ...btnStyles,
          margin: '0 0 2rem 0',
          'border-left': `0.1rem solid ${colors.hwayzGray}`
        }
        : {
          ...btnStyles,
          margin: '0',
          padding: '0 8px',
          border: `0.2rem solid ${borderColor}`,
          'text-align': 'center',
          'font-weight': '400 !important',
          'font-size': '1.3rem'
        }
    },

    showMenu: {
      get() {
        return this.value
      },
      set(showMenu) {
        this.$emit('input', showMenu)
      }
    }
  },

  methods: {
    closeMenu() {
      this.showMenu = false
    },
    customOption(item) {
      return `${this.selectParams.prefix || ''}${this.commaSeparated(
        item
      )}${this.selectParams.suffix || ''}`
    },

    commaSeparated(val) {
      return (val || '').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>

<style lang="sass">
#menuCard
  overflow: hidden

#customInput
  width: 100%
  background: $hwayzWhite
  text-transform: none
  cursor: pointer
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
  padding-left: 1rem
  padding-right: 1rem
  .v-btn__content
    justify-content: start !important
</style>
